<template>
  <section class="marquee-section">
    <!-- Upper Marquee Section -->
    <div class="marquee-content">
      <div class="marquee-item marquee-right">
        <img :src="shopifyData.marqueeImage" alt="Marquee Image" />
      </div>
      <div class="marquee-item marquee-right">
        <img :src="shopifyData.marqueeImage" alt="Marquee Image" />
      </div>
      <div class="marquee-item marquee-right">
        <img :src="shopifyData.marqueeImage" alt="Marquee Image" />
      </div>
      <div class="marquee-item marquee-right">
        <img :src="shopifyData.marqueeImage" alt="Marquee Image" />
      </div>
      <div class="marquee-item marquee-right">
        <img :src="shopifyData.marqueeImage" alt="Marquee Image" />
      </div>
      <div class="marquee-item marquee-right">
        <img :src="shopifyData.marqueeImage" alt="Marquee Image" />
      </div>
      <div class="marquee-item marquee-right">
        <img :src="shopifyData.marqueeImage" alt="Marquee Image" />
      </div>
    </div>

    <!-- Bottom Marquee Section -->
    <div class="marquee-content">
      <div class="marquee-item marquee-left">
        <img
          :src="shopifyData.marqueeImage"
          alt="Marquee Image"
          loading="lazy"
          aria-hidden="true"
          aria-label="Marquee Image"
          width=""
          height=""
        />
      </div>
      <div class="marquee-item marquee-left">
        <img
          :src="shopifyData.marqueeImage"
          alt="Marquee Image"
          loading="lazy"
          aria-hidden="true"
          aria-label="Marquee Image"
          width=""
          height=""
        />
      </div>
      <div class="marquee-item marquee-left">
        <img
          :src="shopifyData.marqueeImage"
          alt="Marquee Image"
          loading="lazy"
          aria-hidden="true"
          aria-label="Marquee Image"
          width=""
          height=""
        />
      </div>
      <div class="marquee-item marquee-left">
        <img
          :src="shopifyData.marqueeImage"
          alt="Marquee Image"
          loading="lazy"
          aria-hidden="true"
          aria-label="Marquee Image"
          width=""
          height=""
        />
      </div>
      <div class="marquee-item marquee-left">
        <img
          :src="shopifyData.marqueeImage"
          alt="Marquee Image"
          loading="lazy"
          aria-hidden="true"
          aria-label="Marquee Image"
          width=""
          height=""
        />
      </div>
      <div class="marquee-item marquee-left">
        <img
          :src="shopifyData.marqueeImage"
          alt="Marquee Image"
          loading="lazy"
          aria-hidden="true"
          aria-label="Marquee Image"
          width=""
          height=""
        />
      </div>
      <div class="marquee-item marquee-left">
        <img
          :src="shopifyData.marqueeImage"
          alt="Marquee Image"
          loading="lazy"
          aria-hidden="true"
          aria-label="Marquee Image"
          width=""
          height=""
        />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.marquee-section {
  overflow: hidden;
  background: #151515;
  padding: 10px 0;
}

.marquee-content {
  display: flex;
}

.marquee-item {
  flex: 0 0 75vw;
  height: 70px;
}

.marquee-item img {
  display: block;
  width: 100%;
  height: 100%;
}

/* Upper marquee moving to the right */
.marquee-right {
  animation: marqueeRight 18s linear infinite;
}

/* Bottom marquee moving to the left */
.marquee-left {
  animation: marqueeLeft 18s linear infinite;
}

@keyframes marqueeRight {
  0% {
    transform: translateX(-144vw);
  }

  100% {
    transform: translateX(0vw);
  }
}

@keyframes marqueeLeft {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-144vw);
  }
}

@media screen and (max-width: 567px) {
  .marquee-item {
    flex: 0 0 100vw;
    height: 35px;
  }
}
</style>
